<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-trophy icon"></i>
        Top links
      </h1>
    </div>
  </div>

  <div class="align p-4 space_title">
    <div v-if="!loading && articlesTopLinks.data" class="card">
      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>Posição</th>
            <th>Título</th>
            <th>Site</th>
            <th>Visitas</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(article, key) in articlesTopLinks.data" :key="key">
            <td>
              {{ key + 1 }}º
            </td>
            <td>
              {{ article.title }}
            </td>
            <td>
              {{ article.site_name }}
            </td>
            <td>
              {{ $numberFormat(article.visits) }}
            </td>
            <td>
              <PrimaryButton class="small" @click="copyLink(article.url)">
                <i class="fa-regular fa-copy me-1"></i>
                Link
              </PrimaryButton>
            </td>
          </tr>

          <tr class="no_result" v-if="!articlesTopLinks || (articlesTopLinks.data && !articlesTopLinks.data.length)">
            <td colspan="5">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

  </div>
</template>
  
<script setup>
import { onBeforeMount, ref } from 'vue';
import { useArticleStore } from '@/stores/ArticleStore'
import { useAuthStore } from '@/stores/AuthStore'
import { storeToRefs } from 'pinia';
import PrimaryButton from '@/components/PrimaryButton.vue'
import { useToast, TYPE } from "vue-toastification"

import { inject } from 'vue';
import axios from "axios";
const loader = inject('$loader');
const loading = ref(true);
let cancelTokenSource = null;
const articleStore = useArticleStore();
const authStore = useAuthStore();
const toast = useToast();
const { articlesTopLinks } = storeToRefs(articleStore);
const { user } = storeToRefs(authStore);

onBeforeMount(() => {
  loadArticlesTopLinks();
});

async function loadArticlesTopLinks() {
  loader.show();
  loading.value = true;

  if (cancelTokenSource) {
    cancelTokenSource.cancel('Cancelado devido a nova busca');
  }

  cancelTokenSource = axios.CancelToken.source();

  await articleStore.getArticlesTopLinks(cancelTokenSource);

  loader.hide();
  loading.value = false;
}

async function copyLink(url) {
  const linkWithHash = url + '?dv=' + user.value.hash;
  
  try {
    await navigator.clipboard.writeText(linkWithHash);
    toast('Link copiado', { type: TYPE.SUCCESS, timeout: 3000, pauseOnFocusLoss: false });
  } catch (err) {
    console.error('Erro ao copiar link:', err);
    toast('Erro ao copiar link', { type: TYPE.ERROR, timeout: 3000, pauseOnFocusLoss: false });
  }
}
</script>